import { render, staticRenderFns } from "./PreviewActivity.vue?vue&type=template&id=5c163636&"
import script from "./PreviewActivity.vue?vue&type=script&lang=js&"
export * from "./PreviewActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports